import PreInstall from './PreInstall';

export default PreInstall;
